<script>
import LazyImage from "@/components/atoms/lazy-image";
import Card from "@/components/molecules/card";

import pointFideliteConversion from "@/assets/images/point-fidelite-conversion.png";

export default {
  name: "FideliteMerchPoints",
  components: {
    LazyImage,
    Card
  },
  setup() {
    return {
      pointFideliteConversion
    };
  },
  props: {}
};
</script>
<template>
  <Card
    radius="md"
    border-color="grey-5"
    class="u-p-none"
  >
    <div class="c-fidelite-merch-points">
      <div class="c-fidelite-merch-points__text">
        <p class="u-font-24 u-font-700 u-font-secondary u-mb-md">
          100% de vos achats récompensés&nbsp;!
        </p>
        <p>
          Présentez votre carte à chaque passage en caisse ou renseignez-là sur votre compte client cora.fr pour cumuler des points.<br>
          Dès 1000 points cumulés transformez-les en €urocora directement en caisse ou sur cora.fr.
        </p>
      </div>
      <LazyImage
        :src="pointFideliteConversion"
        alt="1 euro dépensé égal 1 point fidélité, 1000 Points égal 8 euros en eurocora, 2000 Points égal 20 euros en eurocora, 3000 points égal 30 euros en eurocora"
        width="475"
        height="274"
        class="c-fidelite-merch-points__img"
      />
    </div>
  </Card>
</template>
<style lang="scss" scoped>
@import "@/assets/styles/components/fidelite-merch-points.scss";
</style>
